<template>
  <el-dialog title="收货地址选择" :visible.sync="dialogVisible" center @opened="dialogOpen" @closed="dialogClose"
    :append-to-body="true" width="60%" v-loading="loading" element-loading-text="加载中..." :close-on-click-modal="false">
    <el-card class="d2-mb-10" :body-style="{ padding: '5px 15px 15px 15px' }">
      <el-radio-group v-model="checkList">
        <el-row :gutter="15">
          <el-col :span="24" class="d2-mt-10 sign_checkbox" v-for="(unit,i) in signUpInfo" :key="i">
            <el-radio class="sign_checkbox" :label="unit.id">
              <p>{{unit.name}} {{unit.tel}}</p>
              <p>{{unit.address}}</p>
            </el-radio>
            <i class="el-icon-edit" @click="editAddressHandle(unit)"></i>
          </el-col>
        </el-row>
      </el-radio-group>
    </el-card>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addAddressHandle">新增</el-button>
      <el-button type="primary" @click="submitHandle">确认</el-button>
    </div>
    <edit-address v-model="addressShow" :adddata='adddata' @submit='GetAddressList'></edit-address>
  </el-dialog>
</template>
<script>
  import * as indexService from "@/api/sys/index";
  import editAddress from "./editAddress";
  export default {
    name: "deliveryAddress",
    components: {
      editAddress
    },
    props: {
      address: Object,
      value: Boolean,
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        signUpInfo: [],
        shippingAddress: null,
        checkList: [],
        addressShow: false,
        adddata: {}
      };
    },
    watch: {
      value(val) {
        this.dialogVisible = val;
      },
      dialogVisible(val) {
        this.$emit("input", val);
      },
    },
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    methods: {
      dialogOpen() {
        console.log(this.address)
        this.GetAddressList()
      },
      GetAddressList() {
        this.loading = true;
        let prams = {
          filter: [{key:"MemberCode",value:this.unitname.uInfo.Code,sqlOperator:"EN"}],
          start: 1,
          limit: 1000,
          shortTitle: "收货地址视图",
        };
        indexService.GetDiseaseType(prams).then((res) => {
          if (res.success) {
            var {
              data
            } = res;
            var list = [];
            for (var i = 0; i < data.length; i++) {
              var {
                ID,
                Mobile,
                ReceiverName,
                Address
              } = data[i];
              list.push({
                id: ID,
                name: ReceiverName,
                tel: Mobile,
                address: Address,
              });
            }
            this.$set(this, "signUpInfo", list);
          }
          this.loading = false;
        }).catch((err) => {
          this.$message.error(err)
          this.loading = false;
        });
      },
      editAddressHandle(item) {
        this.adddata = item;
        this.addressShow = true;
      },
      addAddressHandle() {
        this.adddata = {};
        this.addressShow = true;
      },
      // 提交地址
      submitHandle() {
        if (this.checkList.length == 0) {
          this.$message.error('请选择地址！')
          return;
        }
        var find = this.signUpInfo.find((item) => item.id == this.checkList);
        this.$emit("submit", find);
        this.dialogClose();
      },
      dialogClose() {
        this.dialogVisible = false;
        this.applyArray = [];
      },
    },
  };
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__body {
    padding: 5px 20px 10px 20px;

    &::-webkit-scrollbar {
      // 是否显示
      display: none;
      width: 6px;
      padding-right: 4px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      -webkit-border-radius: 3px;
      border-radius: 3px;
      background-color: #c6c6c6;
    }
  }

  .sign_checkbox,
  .sign_checkbox /deep/ .el-checkbox__label {
    display: flex;
    align-items: center;
  }

  .sign_checkbox .sign_checkbox {
    flex: 1;
  }

  .sign_checkbox i {
    font-size: 22px;
    color: #7a7a7a
  }
</style>